export default __webpack_public_path__ + "static/automotive-5e2ec52b338f40dfc0cec7d0a484b1c9.webp";